import CardPet from "../../components/CardPet";
import Footer from "../../components/Footer";
import Navbar from "../../components/NavBar";

function AddPet() {
    return (
        <>
            <Navbar />
            <CardPet />
            <Footer />
        </>
    )
}

export default AddPet;